import React from 'react';

export const NotFoundPage: React.FC = () => {
  return <div className="not-found">Ничего не найдено</div>;
};
